module.exports = __webpack_public_path__ + "img/home_title12.49471fc2.png";